import { SWReactIcons } from "@similarweb/icons";
import { colorsPalettes } from "@similarweb/styles";

import { generateAutomationName } from "../../../helpers/generateAutomationName";

import { StyledDate } from "./styles";

type DurationSchema = {
    duration: string;
};

const Duration = ({ duration }: DurationSchema) => (
    <StyledDate data-automation={generateAutomationName("activationWidget", ["duration", "indication"])}>
        <SWReactIcons
            iconName="daily-ranking"
            iconColor={colorsPalettes.carbon[100]}
            size="xs"
        />
        <span>{duration}</span>
    </StyledDate>
);

export default Duration;
